import { render, staticRenderFns } from "./pedidos-transferencia.vue?vue&type=template&id=6d39dbec&scoped=true&"
import script from "./pedidos-transferencia.vue?vue&type=script&lang=js&"
export * from "./pedidos-transferencia.vue?vue&type=script&lang=js&"
import style0 from "./pedidos-transferencia.vue?vue&type=style&index=0&id=6d39dbec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d39dbec",
  null
  
)

export default component.exports